"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    svg {\n      width: auto;\n      height: 24px;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    * {\n      margin: 0 12px;\n\n      &:first-child {\n        margin-left: 0;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navbarGroupLogo = exports.navbarGroupLinks = exports.navbarGroupBase = void 0;

var _stylitas = require("@creditas/stylitas");

var navbarGroupBase = function navbarGroupBase(_ref) {
  var logo = _ref.logo;
  return (0, _stylitas.css)(_templateObject(), logo ? 'center' : 'stretch');
};

exports.navbarGroupBase = navbarGroupBase;

var navbarGroupLinks = function navbarGroupLinks(_ref2) {
  var links = _ref2.links;
  return links && (0, _stylitas.css)(_templateObject2());
};

exports.navbarGroupLinks = navbarGroupLinks;

var navbarGroupLogo = function navbarGroupLogo(_ref3) {
  var logo = _ref3.logo;
  return logo && (0, _stylitas.css)(_templateObject3());
};

exports.navbarGroupLogo = navbarGroupLogo;